import styled from 'styled-components';
import { Link } from '@/components/Link';

// This was originally a styled aside, but apparently putting an aside within
// a section is bad for accessibility as they are both landmarks.
export const Aside = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  gap: var(--spacing-base);
  max-width: 422px;
  padding: 12px;
  background: var(--brand-50);
  border: 1px solid var(--grey-300);
  border-radius: var(--radius-large);

  & > svg {
    width: 24px;
    min-width: 24px;
    height: 24px;

    & path {
      stroke: var(--brand-700);
    }
  }

  & h3 {
    margin-block-end: 4px;
  }

  & div.messageBody {
    margin-block-end: 12px;
  }
`;

export const Cta = styled(Link)`
  &:after {
    display: inline-block;
    content: url('/Styles/Images/ArrowRight.svg');
    width: 20px;
    height: 20px;
    margin-inline-start: 8px;
    vertical-align: bottom;
  }

  &,
  &:after,
  &:hover:after,
  &[data-hovered]:after,
  &[data-disabled]:after,
  &[data-focus-visible]:after {
    text-decoration: none;
  }
`;
